const environment = {
  debug: true,
  baseUrl: "https://genio-backend.canguru.dev/api/v1/",
  storageKey:
    "7a9f3e2b8c4d1a6f5e9b7c2d8a4f1e6b3c9a5d7f2e8b4a1c6d9f3e7b5a2c8d4f1e",
  baseKey: "ehr_cme_debug",
};

export default environment;
